import { useState, useCallback } from 'react';

export function useUpgradePrompt() {
  const [promptProps, setPromptProps] = useState(null);
  // console.log("promptProps is ", promptProps);
  const showUpgradePrompt = useCallback((checkResult) => {
    if (!checkResult || checkResult.allowed) return;
    setPromptProps(checkResult);
  }, []);

  const closeUpgradePrompt = useCallback(() => setPromptProps(null), []);

  return { promptProps, showUpgradePrompt, closeUpgradePrompt };
}
